import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=2e4403a8&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=2e4403a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4403a8",
  null
  
)

export default component.exports